"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryStorageBackend = void 0;
var MemoryStorageBackend = /** @class */ (function () {
    function MemoryStorageBackend(saveItemsAsync, items) {
        if (items === void 0) { items = {}; }
        this.items = items;
        this.saveItemsAsync = saveItemsAsync;
        this.saveItemsAsync.bind(this);
        this.getItem.bind(this);
        this.removeItem.bind(this);
        this.clear.bind(this);
        this.setItem.bind(this);
    }
    MemoryStorageBackend.prototype.getItem = function (name) {
        return Promise.resolve(this.items[name]);
    };
    MemoryStorageBackend.prototype.removeItem = function (name) {
        delete this.items[name];
        return this.saveItemsAsync(this.items);
    };
    MemoryStorageBackend.prototype.clear = function () {
        this.items = {};
        return this.saveItemsAsync(this.items);
    };
    MemoryStorageBackend.prototype.setItem = function (name, value) {
        this.items[name] = value;
        return this.saveItemsAsync(this.items);
    };
    return MemoryStorageBackend;
}());
exports.MemoryStorageBackend = MemoryStorageBackend;
//# sourceMappingURL=memoryStorageBackend.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@axa-fr/react-oidc/dist/vanilla/memoryStorageBackend.js
// module id = 2129
// module chunks = 0